module.exports = {
	"swell": {
		"unit": "ft",
		"blocks": [
			{
				"color": "rgb(0,0,204)",
				"position": "2.63"
			},
			{
				"color": "rgb(0,51,255)",
				"position": "5.26"
			},
			{
				"color": "rgb(0,204,255)",
				"position": "7.89"
			},
			{
				"color": "rgb(0,255,255)",
				"position": "10.53"
			},
			{
				"color": "rgb(102,255,204)",
				"position": "13.16"
			},
			{
				"color": "rgb(0,255,51)",
				"position": "15.79"
			},
			{
				"color": "rgb(0,204,51)",
				"position": "18.42"
			},
			{
				"color": "rgb(153,255,102)",
				"position": "21.05"
			},
			{
				"color": "rgb(255,255,102)",
				"position": "23.68"
			},
			{
				"color": "rgb(255,255,0)",
				"position": "26.32"
			},
			{
				"color": "rgb(255,153,0)",
				"position": "28.95"
			},
			{
				"color": "rgb(255,102,0)",
				"position": "34.21"
			},
			{
				"color": "rgb(255,51,0)",
				"position": "39.47"
			},
			{
				"color": "rgb(255,0,0)",
				"position": "44.74"
			},
			{
				"color": "rgb(204,0,0)",
				"position": "50.00"
			},
			{
				"color": "rgb(153,0,0)",
				"position": "55.26"
			},
			{
				"color": "rgb(153,0,102)",
				"position": "63.16"
			},
			{
				"color": "rgb(204,0,255)",
				"position": "71.05"
			},
			{
				"color": "rgb(255,0,255)",
				"position": "81.58"
			},
			{
				"color": "rgb(226,95,206)",
				"position": "100"
			}
		],
		"labels": [
			{
				"value": "2",
				"position": "5.26"
			},
			{
				"value": "4",
				"position": "10.53"
			},
			{
				"value": "6",
				"position": "15.79"
			},
			{
				"value": "8",
				"position": "21.05"
			},
			{
				"value": "10",
				"position": "26.32"
			},
			{
				"value": "13",
				"position": "34.21"
			},
			{
				"value": "15",
				"position": "39.47"
			},
			{
				"value": "17",
				"position": "44.74"
			},
			{
				"value": "19",
				"position": "50.00"
			},
			{
				"value": "21",
				"position": "55.26"
			},
			{
				"value": "24",
				"position": "63.16"
			},
			{
				"value": "27",
				"position": "71.05"
			},
			{
				"value": "31",
				"position": "81.58"
			},
			{
				"value": "35",
				"position": "92.11"
			}
		]
	},
	"wind": {
		"unit": "kts",
		"blocks": [
			{
				"color": "rgb(0,0,255)",
				"position": "6.25"
			},
			{
				"color": "rgb(0,120,255)",
				"position": "12.50"
			},
			{
				"color": "rgb(1,254,153)",
				"position": "18.75"
			},
			{
				"color": "rgb(2,253,65)",
				"position": "25.00"
			},
			{
				"color": "rgb(128,255,0)",
				"position": "31.25"
			},
			{
				"color": "rgb(255,225,0)",
				"position": "37.50"
			},
			{
				"color": "rgb(255,138,0)",
				"position": "43.75"
			},
			{
				"color": "rgb(255,74,0)",
				"position": "50.00"
			},
			{
				"color": "rgb(230,0,0)",
				"position": "56.25"
			},
			{
				"color": "rgb(156,0,0)",
				"position": "62.50"
			},
			{
				"color": "rgb(99,0,0)",
				"position": "68.25"
			},
			{
				"color": "rgb(133,41,115)",
				"position": "75.00"
			},
			{
				"color": "rgb(183,57,157)",
				"position": "81.25"
			},
			{
				"color": "rgb(201,82,177)",
				"position": "87.50"
			},
			{
				"color": "rgb(220,143,205)",
				"position": "93.75"
			}
		],
		"labels": [
			{
				"value": "4",
				"position": "6.25"
			},
			{
				"value": "6",
				"position": "12.50"
			},
			{
				"value": "8",
				"position": "18.75"
			},
			{
				"value": "10",
				"position": "25.00"
			},
			{
				"value": "12",
				"position": "31.25"
			},
			{
				"value": "14",
				"position": "37.50"
			},
			{
				"value": "16",
				"position": "43.75"
			},
			{
				"value": "19",
				"position": "50.00"
			},
			{
				"value": "22",
				"position": "56.25"
			},
			{
				"value": "28",
				"position": "62.50"
			},
			{
				"value": "34",
				"position": "68.25"
			},
			{
				"value": "40",
				"position": "75.00"
			},
			{
				"value": "44",
				"position": "81.25"
			},
			{
				"value": "48",
				"position": "87.50"
			},
			{
				"value": "52",
				"position": "93.75"
			}
		]
	},
	"period": {
		"unit": "sec",
		"blocks": [
			{
				"color": "rgb(0,0,50)",
				"position": "6.25"
			},
			{
				"color": "rgb(5,0,84)",
				"position": "12.50"
			},
			{
				"color": "rgb(9,0,137)",
				"position": "18.75"
			},
			{
				"color": "rgb(0,0,184)",
				"position": "25.00"
			},
			{
				"color": "rgb(0,0,255)",
				"position": "31.25"
			},
			{
				"color": "rgb(0,106,255)",
				"position": "37.50"
			},
			{
				"color": "rgb(0,184,255)",
				"position": "43.75"
			},
			{
				"color": "rgb(255,225,0)",
				"position": "50.00"
			},
			{
				"color": "rgb(255,202,0)",
				"position": "56.25"
			},
			{
				"color": "rgb(255,138,0)",
				"position": "62.50"
			},
			{
				"color": "rgb(255,74,0)",
				"position": "68.75"
			},
			{
				"color": "rgb(230,0,0)",
				"position": "75.00"
			},
			{
				"color": "rgb(156,0,0)",
				"position": "81.25"
			},
			{
				"color": "rgb(99,0,0)",
				"position": "87.50"
			},
			{
				"color": "rgb(75,0,0)",
				"position": "93.75"
			}
		],
		"labels": [
			{
				"value": "4",
				"position": "6.25"
			},
			{
				"value": "6",
				"position": "12.50"
			},
			{
				"value": "8",
				"position": "18.75"
			},
			{
				"value": "10",
				"position": "25.00"
			},
			{
				"value": "11",
				"position": "31.25"
			},
			{
				"value": "12",
				"position": "37.50"
			},
			{
				"value": "13",
				"position": "43.75"
			},
			{
				"value": "14",
				"position": "50.00"
			},
			{
				"value": "15",
				"position": "56.25"
			},
			{
				"value": "16",
				"position": "62.50"
			},
			{
				"value": "17",
				"position": "68.75"
			},
			{
				"value": "18",
				"position": "75.00"
			},
			{
				"value": "19",
				"position": "81.25"
			},
			{
				"value": "20",
				"position": "87.50"
			},
			{
				"value": "21",
				"position": "93.75"
			}
		]
	},
	"hireswind": {
		"unit": "kts",
		"blocks": [
			{
				"color": "#FFFFFF",
				"position": "8.33"
			},
			{
				"color": "#DEEFFF",
				"position": "16.67"
			},
			{
				"color": "#B3E0FF",
				"position": "25.00"
			},
			{
				"color": "#EDFFC5",
				"position": "33.33"
			},
			{
				"color": "#FFFF87",
				"position": "41.67"
			},
			{
				"color": "#FED88F",
				"position": "50.00"
			},
			{
				"color": "#FEC492",
				"position": "58.33"
			},
			{
				"color": "#FD8B8A",
				"position": "66.67"
			},
			{
				"color": "#A36665",
				"position": "75.00"
			},
			{
				"color": "#88668B",
				"position": "83.33"
			},
			{
				"color": "#BE65B9",
				"position": "91.67"
			},
			{
				"color": "#E863E2",
				"position": "100.00"
			}
		],
		"labels": [
			{
				"value": "3",
				"position": "8.33"
			},
			{
				"value": "6",
				"position": "16.67"
			},
			{
				"value": "11",
				"position": "25.00"
			},
			{
				"value": "16",
				"position": "33.33"
			},
			{
				"value": "21",
				"position": "41.67"
			},
			{
				"value": "27",
				"position": "50.00"
			},
			{
				"value": "33",
				"position": "58.33"
			},
			{
				"value": "40",
				"position": "66.67"
			},
			{
				"value": "48",
				"position": "75.00"
			},
			{
				"value": "55",
				"position": "83.33"
			},
			{
				"value": "63",
				"position": "91.67"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ChartLegend/scales.json
// module id = 921
// module chunks = 11